import { defineComponent, resolveComponent, createBlock, openBlock, withCtx, createVNode, renderSlot, createTextVNode, toDisplayString } from "vue";
import { _ as _sfc_main$1 } from "./p-icon.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  ...{
    name: "PInfoIcon"
  },
  __name: "p-info-icon",
  props: {
    text: { default: null }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      const _component_VTooltip = resolveComponent("VTooltip");
      return openBlock(), createBlock(_component_VTooltip, {
        "popper-triggers": ["hover"],
        delay: { show: 750, hide: 0 },
        disabled: !_ctx.$slots.default && !_ctx.text
      }, {
        popper: withCtx(() => [
          renderSlot(_ctx.$slots, "default", {}, () => [
            createTextVNode(toDisplayString(_ctx.text), 1)
          ])
        ]),
        default: withCtx(() => [
          createVNode(_sfc_main$1, {
            icon: "info",
            class: "block h-3 w-3",
            width: "12"
          })
        ]),
        _: 3
      }, 8, ["disabled"]);
    };
  }
});
export {
  _sfc_main as _
};
